<template>
  <DiscordWidget/>
</template>

<script>
import DiscordWidget from "@/components/DiscordWidget.vue";
export default {
  name: "Home",
  components: {
    DiscordWidget: DiscordWidget
  },
  mounted() {
    componentHandler.upgradeDom();
    // componentHandler.upgradeElement(this.$el.childNodes[0]);
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Home.vue